import create from 'zustand';

/**
 * @param {string} dataKey La key en la cual almacenar los datos
 * @param {number} [ttlMs=180000] Cuantos ms durará activa la data
 */
export function createBasicCacheStore(
  dataKey,
  ttlMs = 3 * 60 * 1000,
) {
  return create((set, get) => ({
    cache: {},
    setCache: (data, params, total) => {
      set((state) => ({
        cache: {
          ...state.cache,
          [params]: { data, lastFetched: Date.now(), total },
        },
      }));
    },
    getCache: (params) => {
      const entry = get().cache[params];
      if (entry && Date.now() - entry.lastFetched < ttlMs) {
        return { [dataKey]: entry.data, total: entry.total };
      }
      return null;
    },
    clearCache: () => set({ cache: {} }),
  }));
}export const useSalesChannelStore = createBasicCacheStore('salesChannels');
